import { render, staticRenderFns } from "./VideoCard.vue?vue&type=template&id=ad59766c&scoped=true&"
import script from "./VideoCard.vue?vue&type=script&lang=js&"
export * from "./VideoCard.vue?vue&type=script&lang=js&"
import style0 from "../../../assets/css/accountmove.css?vue&type=style&index=0&id=ad59766c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ad59766c",
  null
  
)

export default component.exports